import { combineReducers } from "redux";
import { sidebarReducer } from "./sidebarReducer";
import { userReduer } from "./userReducer";
import { AuthReduer } from "./authTokenReducer";
import { changeTenantReducer } from "./changeTenantReducer";
import { apiModeReducer } from "./runAPIReducer"
import { candidateTabVal } from "./candidateTabNumReducer"
import { apiErrMsg } from './apiErrMsgReducer';
import { userAddressReducer } from "./userAddressReducer";
import { activeCandidateTabs } from "./tenantCandidateTabReducer";
import { onrowClick } from "./CandidateRowClickReducer";
import { tenantIntegrationViewReducer } from "./tenantIntegrationViewReducer";
import { dashboardViewReducer } from "./dashboardViewReducer";
import { projectDetailsReducer } from "./projectDetailsReducer";
import { increaseCountReducer } from "./increaseCountReducer";
import { updateProjectListReducer } from "./updateProjectListReducer";
import SelectResourceReducer from "./SelectResourceReducer";
import { alertMessageReducer } from "./alertMessageReducer";
import { projectOverviewReducer } from "./projectOverviewReducer";
import { cohortReducer } from "./cohortReducer";
import { cohortCountReducer } from "./cohortCountReducer";
import { fhirMetaDataReducer } from "./fhirMetaDataReducer";

const reducers = combineReducers({
  sidebarStatus: sidebarReducer,
  logedUser: userReduer,
  authToken: AuthReduer,
  tenantIdValue: changeTenantReducer,
  apiModeReducer: apiModeReducer,
  candidateTabVal: candidateTabVal,
  apiErrMsg: apiErrMsg,
  userAddress: userAddressReducer,
  activeCandidateTabs: activeCandidateTabs,
  onrowClick: onrowClick,
  tenantIntegrationViewReducer: tenantIntegrationViewReducer,
  dashboardViewStatus: dashboardViewReducer,
  projectDetails: projectDetailsReducer,
  increaseCount:increaseCountReducer,
  updateProjectList:updateProjectListReducer,
  selectResource: SelectResourceReducer,
  alertMessageReducer: alertMessageReducer,
  projectOverviewReducer:projectOverviewReducer,
  cohortReducer:cohortReducer,
  cohortCountReducer:cohortCountReducer,
  fhirMetaData:fhirMetaDataReducer

});

export default reducers;
